/**
 * Environment utility functions
 * This file should have no dependencies to avoid circular dependency issues
 */

export const isDev = window.origin.startsWith('http://localhost');
